import "./Spinner.css";

export default function Spinner() {
    return (
        <div className="w-full flex items-center text-center justify-center mt-4">
            <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
        </div>
    );
}